import { useState } from 'react'

export const useTheme = (): [boolean, (value: boolean) => void] => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(localStorage.getItem('theme') === 'dark')

  //Modify for change localStorage
  const setDarkMode = (value: boolean) => {
    if (value) {
      setIsDarkMode(true)
      localStorage.setItem('theme', 'dark')
    } else {
      setIsDarkMode(false)
      localStorage.setItem('theme', 'white')
    }
  }

  return [isDarkMode, setDarkMode]
}
